<div class="password-reset">
  <h2>Réinitialisation du mot de passe</h2>
  <div *ngIf="successMessage" class="success-message">{{ successMessage }}</div>
  <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>
  <form [formGroup]="passwordResetForm" (ngSubmit)="onSubmit()" *ngIf="!successMessage">
    <div class="form-group">
      <label for="password">Nouveau mot de passe</label>
      <input type="password" id="password" formControlName="password" class="form-control">
      <div *ngIf="passwordResetForm.get('password')?.invalid && (passwordResetForm.get('password')?.dirty || passwordResetForm.get('password')?.touched)">
        <div *ngIf="passwordResetForm.get('password')?.hasError('required')">Le mot de passe est requis.</div>
        <div *ngIf="passwordResetForm.get('password')?.hasError('minlength')">Le mot de passe doit contenir au moins 8 caractères.</div>
      </div>
    </div>
    <div class="form-group">
      <label for="confirmPassword">Confirmez le mot de passe</label>
      <input type="password" id="confirmPassword" formControlName="confirmPassword" class="form-control">
      <div *ngIf="passwordResetForm.get('confirmPassword')?.invalid && (passwordResetForm.get('confirmPassword')?.dirty || passwordResetForm.get('confirmPassword')?.touched)">
        <div *ngIf="passwordResetForm.hasError('passwordMismatch')">Les mots de passe ne correspondent pas.</div>
        <div *ngIf="passwordResetForm.get('confirmPassword')?.hasError('required')">La confirmation du mot de passe est requise.</div>
      </div>
    </div>
    <button type="submit" [disabled]="passwordResetForm.invalid">Réinitialiser le mot de passe</button>
  </form>
</div>
